export const LOGGING_EVENTS = {
  CLICK_CLOSE_EMERGENCY_WARNING:
    'user_action.aggregated_availability.appt_info.emergency_warning.close_warning',
  CLICK_EMERGENCY_WARNING:
    'user_action.aggregated_availability.appt_info..emergency_warning.click_warning',
  PROVIDER_TIMESLOT_SELECTED:
    'user_action.aggregated_availability.provider_timeslot_selected'
} as const;
